import { ofType } from "redux-observable";
import { mapTo, skip, switchMapTo, take } from "rxjs/operators";
import { utilFps } from "../../../../utils/utilFps";
import { utilTick } from "../../../../utils/utilTick";
import { TypeActionApp } from "../../../app/actionApp";
import { actionGameTrackingUpdateFps } from "../../actionGameTracking";
import { IdGameTrackingFpsEventName } from "../IdGameTrackingFpsEventName";
export var epicGameTrackingFpsMemoryUsageGameJoined = function (action$, state$) {
    return action$.pipe(ofType(TypeActionApp.Init), take(1), switchMapTo(utilTick.frame$), skip(utilFps.gameJoinedFpsBuffer), take(1), mapTo(actionGameTrackingUpdateFps(IdGameTrackingFpsEventName.GAME_JOINED)));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/game-tracking/fps/epics/epicGameTrackingFpsMemoryUsageGameJoined.ts
// module id = 1863
// module chunks = 3